import { render, staticRenderFns } from "./FlightCard.vue?vue&type=template&id=b1c5aac0&scoped=true"
import script from "./FlightCard.vue?vue&type=script&lang=js"
export * from "./FlightCard.vue?vue&type=script&lang=js"
import style0 from "./FlightCard.vue?vue&type=style&index=0&id=b1c5aac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c5aac0",
  null
  
)

export default component.exports